<template>
    <div>
        <div style="display: flex;width:100%">
            <div style="margin-top: 10px;text-align: center;width:100%" class="tab">
                <el-card class="box-card">
                    <div>
                        <table>
                            <tr>
                                <td style="width:60px">{{ $t('getapi[4042]') }}：</td>
                                <td style="width:150px;">
                                    <el-date-picker
                                            v-model="sdate"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                    >
                                    </el-date-picker>
                                </td>
                                <td style="width:60px">{{ $t('getapi[3327]') }}：</td>
                                <td style="width:150px;">
                                    <el-date-picker
                                            v-model="edate"
                                            type="date"
                                            value-format="yyyy-MM-dd"
                                    >
                                    </el-date-picker>
                                </td>
                                <td>
                                    <el-button type="primary" size="mini" @click="search" style="margin-left: 8px">{{$t('getapi[1980]')}}</el-button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div>
                        <div id="main" :style="{ width: '100%', height: tableHeight + 'px' }"></div>
                    </div>
                </el-card>

            </div>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    import echarts from 'echarts';
    import 'echarts-gl';
    export default {
        name: '4_getmeterenergydata',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-200
            }
        },
        data() {
            return {
                userData:[],
                charts: '',
                sdate: '',
                edate: '',
                data:{},
            };
        },
        beforeDestroy(){
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.year = new Date().getFullYear()
        },
        methods: {
            search(){
                let that = this
                if(that.sdate == '' || that.edate == ''){
                    that.$message.warning(this.$t("getapi[9462]"))
                    return false
                }
                let loadingInstance = Loading.service(Common.maskoption1);
                let data = {
                };
                $.ajax({
                    url: Common.MobileUrl + 'api/Maintenance/GetMeterEnergyData?Group=' +
                        that.userData.Login_Group+'&DBName='+that.userData.Login_DB+'&BeginDate='+
                        that.sdate+'&EndDate='+that.edate+'&KeyCode=WTLXNH2026',
                    type: 'post',
                    data: JSON.stringify(data),
                    contentType: 'application/json',
                    success: function (res) {
                        if (res.Success == 1) {
                            that.data = res.DataContent
                            that.draw(that.data)
                        } else {
                            that.$message.error(res.Msg);
                        }
                        loadingInstance.close()
                    },
                    error: function (xhr, errorType, error) {
                        loadingInstance.close()
                        that.$message.error('Ajax request error, errorType: ' + errorType + ', error: ' + error);
                    }
                });
            },
            draw(data){
                let that = this;
                console.log(data)
                that.charts = echarts.init(document.getElementById("main"));
                let list = {
                    datax: [],
                    datay:[],
                }
                for(let i=0;i<data.length;i++){
                    list.datax = [...list.datax,data[i].ObjName]
                    list.datay = [...list.datay,data[i].ValueD]
                }
                let option = {
                    title: {
                        text:  this.$t("getapi[13543]"),
                        x:'center',
                        y:'top',
                        textAlign:'left'
                    },
                    legend: {
                        data: ['kW·h'],
                        right: 50,
                    },
                    xAxis: {
                        type: 'category',
                        label: {
                            show: true,
                            position: 'insideRight'
                        },
                        data: list.datax,
                        axisLabel:{
                            rotate:45
                        }
                    },
                    yAxis: [
                        {
                            type: 'value',
                            name: 'kW·h',
                            axisLabel: {
                                formatter: '{value}'
                            },
                            splitLine: {
                                show: false  // 隐藏网格线
                            }
                        }
                    ],
                    series: [{
                        name:'kW·h',
                        data: list.datay,
                        type: 'bar',
                        showBackground: true,
                        itemStyle:{
                            normal:{
                                color:'#409eff'
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                    }]
                }
                that.charts.clear();
                that.charts.setOption(option);
            },
        }
    };
</script>

<style scoped lang="less">

</style>
